export default __webpack_public_path__ + "static/1.2-9baca26481c0ed24f5a8fbd39e487df5.webp";